import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { FormControl, Navbar, NavbarBrand, NavItem, NavbarHeader, NavDropdown, Nav, Container, Row, Button, Col, Form, Card, InputGroup, Table } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';


import ReactCountryFlag from "react-country-flag"
import carbonEodPricingInputs from '../json/carbonEodPricingInputs.json';
import countryProductYearPricesPriorDay from '../json/countryTechYearPricesPriorDay.json';

import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'

// Converting alpha2 to alpha3
var listOfIsoCountries = require("i18n-iso-countries");


// **********************************************
// Data from JSON or DB
// **********************************************
// Retrieve original values from carbonEodPricingInputs.json
// **********************************************
const geoTechList = {}
carbonEodPricingInputs[0].masterCountries.map(masterCountry => {
    const technologies = Object.keys(masterCountry.technologies)
    technologies.forEach((technology, index) => {
        geoTechList[masterCountry.properties.iso3 + "_" + technology] = masterCountry.technologies[technology];
    })
})


// **********************************************
// Data from JSON or DB
// **********************************************
// Retrieve original values from carbonEodPricingInputs.json
// **********************************************
var arrayCountriesJson = []
const peggedCountryList = {}
carbonEodPricingInputs[0].masterCountries.map(masterCountry => {
    arrayCountriesJson.push(masterCountry.properties.iso3.toUpperCase())
    masterCountry.peggedCountries.map(peggedCountry => {
        peggedCountryList[peggedCountry.properties.iso3] = peggedCountry.percentage;
        arrayCountriesJson.push(peggedCountry.properties.iso3.toUpperCase());
    })
})

// Sort by date
arrayCountriesJson.sort();


// **********************************************
// Data from JSON or DB
// **********************************************
// Retrieve original values from carbonEodPricingInputs.json
// **********************************************
var arrayYears = []
const timeChangeList = {}
const timeChanges = Object.keys(carbonEodPricingInputs[0].timeChange)
timeChanges.forEach((timeChange, index) => {
    timeChangeList[timeChange] = carbonEodPricingInputs[0].timeChange[timeChange].percentage;
    arrayYears.push(timeChange);
})

// Sort by date
arrayYears.reverse();



// **********************************************
// Build an new array of objects (i.e. countries) containing the show attribute
// **********************************************
const arrayCountries = arrayCountriesJson.map((item, index) => {
    return { country: item, show: 1 };
});


// **********************************************
// List of all available products (could come from DB or elsewhere)
// **********************************************
var arrayProducts = [
    { product: "arabica", show: 1 },
    { product: "robusta", show: 0 },
    { product: "excelsa", show: 0 },
    { product: "liberica", show: 0 }
]


const countryProductYearPrices = [];





function PricingGrid(props) {

    // Show or hide card based on onClick event
    const [hidden, setHidden] = useState(true);
    const onClickReduceCard = evt => {
        setHidden(s => !s)
    }



    const [allCountries, setCountries] = useState(true);
    const [numberOfCountriesSelected, setNumberOfCountriesSelected] = useState(0);



    const selectUnselectCountry = evt => {
        const name = evt.target.title
        const value = evt.target.title
        const show = evt.target.getAttribute('value')

        // Change status of object (show=1 or show=0)
        for (let object of arrayCountries) {
            if (object.country === name) {
                if (object.show === 1) {
                    object.show = 0;
                } else {
                    object.show = 1;
                }
            }
        }

        setCountries({
            ...allCountries,
            [name]: value
        })

        // Summing the specified attribute (for colspan attribute)
        const sum = arrayCountries.reduce((accumulator, currentValue) => accumulator + currentValue['show'], 0);
        setNumberOfCountriesSelected(sum)
    }


    const [allProducts, setProducts] = useState(true);
    const [numberOfProductsSelected, setNumberOfProductsSelected] = useState(1);

    const selectUnselectProduct = evt => {
        const name = evt.target.title
        const value = evt.target.title
        const show = evt.target.getAttribute('value')

        // Change status of object (show=1 or show=0)
        for (let object of arrayProducts) {
            if (object.product === name) {
                if (object.show === 1) {
                    object.show = 0;
                } else {
                    object.show = 1;
                }
            }
        }

        setProducts({
            ...allProducts,
            [name]: value
        })


        // Summing the specified attribute (for colspan attribute)
        const sum = arrayProducts.reduce((accumulator, currentValue) => accumulator + currentValue['show'], 0);
        setNumberOfProductsSelected(sum)
    }





    var jsonResponseTimeChange = props.jsonResponseTimeChange;

    var ldcCountry = props.ldcCountryArray;
    var nonLdcCountry = props.nonLdcCountryArray;
    // received parameters from GeoTech
    var geoTech = props.geoTech;

    var jsonResponseCountryPeg = props.jsonResponseCountryPeg;

    var organic = props.organic;
    var non_organic = props.non_organic;
    var fairTrade = props.fairTrade;


    // Check if a country is LDC or not
    function isLdcCountry(countryAlpha3) {
        const ldcCountries = ['MMR', 'UGA']

        if (ldcCountries.includes(countryAlpha3)) {
            return ldcCountry
        } else {
            return nonLdcCountry
        }
    }



    // get price geo
    function getPriceGeoTech(country, tech) {
        const masterCountry1 = ['VNM', 'IDN', 'IND']
        const masterCountry2 = ['BRA', 'COL']
        const masterCountry3 = ['ETH', 'UGA']

        var masterCountry = "none"
        if (masterCountry1.includes(country)) {
            masterCountry = "VNM"
        } else if (masterCountry2.includes(country)) {
            masterCountry = "BRA"
        } else if (masterCountry3.includes(country)) {
            masterCountry = "ETH"
        } else {
            masterCountry = "none"
        }


        if (geoTech.name !== undefined && (((geoTech.name.substring(0, 3)).toUpperCase()) == masterCountry) && tech == (geoTech.name.substring(geoTech.name.indexOf("_") + 1))) {
            geoTechList["" + country.toString().toLowerCase() + "_" + tech + ""] = geoTech.value
            return geoTech.value
        } else {
            return geoTechList["" + masterCountry.toString().toLowerCase() + "_" + tech + ""]
        }

    }


    // get time decay
    function getPercentageTimeChange(year) {
        if (jsonResponseTimeChange.name !== undefined && parseInt(jsonResponseTimeChange.name.substring(jsonResponseTimeChange.name.length - 4)) == year) {
            timeChangeList[year] = jsonResponseTimeChange.value
            return jsonResponseTimeChange.value
        } else {
            return timeChangeList[year]
        }
    }


    // get percentage reg
    function getPercentageRegistry(trend) {
        if (trend == "organic") {
            return organic
        } else if (trend == "non-organic") {
            return non_organic
        } else {
            return 100
        }
    }

    // get percentage reg
    function getPercentageFairTrade(trend) {
        if (trend == "fairTrade") {
            return fairTrade
        } else {
            return 100
        }
    }


    // country peg
    function getPercentageCountryPeg(countryAlpha3) {
        var countryAlpha3LowerCase = countryAlpha3.toString().toLowerCase()

        if (jsonResponseCountryPeg.name !== undefined && jsonResponseCountryPeg.name == countryAlpha3LowerCase) {
            peggedCountryList[countryAlpha3LowerCase] = jsonResponseCountryPeg.value
            return jsonResponseCountryPeg.value
        } else if (countryAlpha3LowerCase == "vnm" || countryAlpha3LowerCase == "bra" || countryAlpha3LowerCase == "eth") {
            return 100
        } else {
            return peggedCountryList[countryAlpha3LowerCase]
        }
    }



    // calculating percentage change (from p1=yesterday to p2=today)
    function getPercentageChange(p2, p1) {
        p2 = parseFloat(p2)
        p1 = parseFloat(p1)

        if (p2 > p1) {
            var difference = (((p2 - p1) / p1) * 100).toFixed(1)
            return <span className="smaller-font-percentage-positive">+{difference}%</span>
        } else if (p2 == 0) {
            return <span className="smaller-font-percentage-neutral"></span>
        } else if (p2 < p1) {
            var difference = (((p1 - p2) / p1) * 100).toFixed(1)
            return <span className="smaller-font-percentage-negative">-{difference}%</span>
        } else {
            return <span className="smaller-font-percentage-neutral"></span>
        }
    }

    // Price calculation for a country-tech-year
    arrayYears.forEach(function (itemYear, index) {
        arrayCountriesJson.forEach(function (itemCountry, index) {
            arrayProducts.forEach(function (product, index) {
                countryProductYearPrices["" + itemCountry + "" + product.product + "" + itemYear + ""] =
                    (
                        getPriceGeoTech(itemCountry, product.product) *
                        //(getPercentageRegistry(props.trend) / 100) *
                        (props.organic / 100) *
                        (props.fairTrade / 100) *
                        //(isLdcCountry(itemCountry) / 100) *
                        (getPercentageTimeChange(itemYear) / 100) *
                        (getPercentageCountryPeg(itemCountry) / 100)
                    ).toFixed(2);
            });
        });
    });



    return (
        <>





            {arrayProducts.map(product => {
                if (product.show == 1) {
                    return (
                        <>
                            <Badge style={{ cursor: 'pointer' }} className="custom-btn-countries-selected" title={product.product} value={product.show} onClick={selectUnselectProduct}>{product.product}</Badge>
                            &nbsp;
                        </>
                    )
                } else {
                    return (
                        <>
                            <Badge style={{ cursor: 'pointer' }} className="custom-btn-countries-unselected" title={product.product} value={product.show} onClick={selectUnselectProduct}>{product.product}</Badge>
                            &nbsp;
                        </>
                    )
                }
            })}

            <br />
            {arrayCountries.map(country => {
                if (country.show == 1) {
                    return (
                        <>
                            <Badge style={{ cursor: 'pointer' }} className="custom-btn-countries-selected" title={country.country} value={country.show} onClick={selectUnselectCountry}>
                                {country.country}&nbsp;&nbsp;
                                <ReactCountryFlag
                                    countryCode={listOfIsoCountries.alpha3ToAlpha2(country.country)}
                                    svg
                                    style={{ height: '0.8em' }}
                                />
                            </Badge>
                            &nbsp;
                        </>
                    )
                } else {
                    return (
                        <>
                            <Badge style={{ cursor: 'pointer' }} className="custom-btn-countries-unselected" title={country.country} value={country.show} onClick={selectUnselectCountry}>
                                {country.country}&nbsp;&nbsp;
                                <ReactCountryFlag
                                    countryCode={listOfIsoCountries.alpha3ToAlpha2(country.country)}
                                    svg
                                    style={{ height: '0.8em' }}
                                />
                            </Badge>
                            &nbsp;
                        </>
                    )
                }
            })}




            {/* ************************** */}
            {/* ************************** */}
            {/* MAIN CARD */}
            {/* ************************** */}
            {/* ************************** */}
            <Card className="Card-Pricing-Table">
                {/*<Card.Header className="Card-Header-Pricing-Table"><kbd style={{ backgroundColor: "var(--" + props.registry + ")", cursor: 'pointer' }} onClick={onClickReduceCard}>{props.registry.toUpperCase()}</kbd>*/}
                <Card.Header className="Card-Header-Pricing-Table" style={{ cursor: 'pointer' }} onClick={() => setHidden(s => !s)}>{props.trend}
                    {/*showElectricity ? <><kbd> Electricity</kbd></> : ""*/}
                    {/*showGas ? <><kbd> Gas</kbd></> : ""*/}

                </Card.Header>
                {!hidden ? null :

                    <Card.Body className="Card-Body-Pricing-Table">

                        <Table responsive striped hover className="table-condensed" style={{ width: "100%", background: "var(--white)", marginTop: "var(--card-margin-top)", paddingBottom: "var(--card-padding-bottom)", margin: 0, padding: 0 }}>
                            <thead className="Card-Thead-Pricing-Table">
                                <tr style={{ border: "0px" }}>
                                    <th style={{ border: "0px" }}></th>
                                    {arrayCountries.map(country => {
                                        if (country.show == 1) {
                                            return (
                                                <th colspan={numberOfProductsSelected}>
                                                    <div style={{ textAlign: "center" }}>
                                                        <Badge bg="dark" style={{ cursor: 'pointer' }} title={country.country} value={country.show} onClick={selectUnselectCountry}>
                                                            {country.country}&nbsp;&nbsp;
                                                            <ReactCountryFlag
                                                                countryCode={listOfIsoCountries.alpha3ToAlpha2(country.country)}
                                                                svg
                                                                style={{ height: '0.8em' }}
                                                            />
                                                        </Badge>
                                                    </div>
                                                </th>
                                            )
                                        }
                                    })}
                                </tr>

                                <tr>
                                    <th>{/*Exp.*/}</th>
                                    {arrayCountries.map(country => {
                                        if (country.show == 1) {
                                            return (
                                                arrayProducts.map(product => {
                                                    if (product.show == 1) {
                                                        return (
                                                            <>
                                                                <th>
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <small><Badge bg="dark" style={{ cursor: 'pointer' }} title={product.product} value={product.show} onClick={selectUnselectProduct}>{product.product}</Badge></small>
                                                                    </div>
                                                                </th>

                                                                {/*<Badge style={{ cursor: 'pointer' }} className="custom-btn-countries-selected" title={product.product} value={product.show} onClick={selectUnselectProduct}><i class="bi bi-check"></i>{product.product}</Badge>*/}
                                                            </>
                                                        )
                                                    }
                                                })
                                            )
                                        }
                                    })}
                                </tr>

                            </thead>


                            <tbody>
                                {arrayYears.map(year => {

                                    return (
                                        <tr>
                                            <td className="smaller-input justified-content-center">{year}</td>

                                            {/* Error in this block */}
                                            {arrayCountries.map(country => {
                                                if (country.show == 1) {
                                                    return (
                                                        arrayProducts.map((product, index) => {
                                                            if (product.show == 1) {
                                                                return (
                                                                    <>
                                                                        <td>
                                                                            <div className="smaller-input justified-content-center" style={{ textAlign: "center" }}>
                                                                                {countryProductYearPrices["" + country.country + "" + product.product + "" + year + ""]}
                                                                                <br />
                                                                                {getPercentageChange(countryProductYearPrices["" + country.country + "" + product.product + "" + year + ""], countryProductYearPricesPriorDay.map(object => object.year[year][country.country.toLowerCase()][product.product]))}
                                                                                {/*getPercentageChange(countryProductYearPrices["" + country + "" + selectedTech[1] + "" + year + ""], countryProductYearPricesOriginal["" + country + "" + selectedTech[1] + "" + year + ""])*/}
                                                                            </div>

                                                                        </td>
                                                                    </>
                                                                )
                                                            }
                                                        })
                                                    )
                                                }
                                            })}


                                        </tr>
                                    )


                                })}


                            </tbody>

                        </Table>

                    </Card.Body >
                }
            </Card >



        </>
    );

}


export default PricingGrid;